import { render, staticRenderFns } from "./RelatorioLogAba.vue?vue&type=template&id=0097d7dd&scoped=true"
import script from "./RelatorioLogAba.vue?vue&type=script&lang=js"
export * from "./RelatorioLogAba.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLogAba.vue?vue&type=style&index=0&id=0097d7dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0097d7dd",
  null
  
)

export default component.exports